<div class="reports-issue-card-cntr">

  <div class="title-cntr">{{configuration?.Title}}    <mat-icon>receipt_long</mat-icon></div>
  <div class="form-cntr">

        <ct-control [configuration]="qtyControl"></ct-control>
        <ct-control [configuration]="supplierControl"></ct-control>

        <h3 style="place-self: start;">Data scadenza fornitura</h3>

        <div class="date-cntr">
          <ct-control [configuration]="InvoiceDueDateFromControl"></ct-control>
          <ct-control [configuration]="InvoiceDueDateToControl"></ct-control>
        </div>

  </div>
  <div class="button cntr">

      <ct-button [configuration]="submitButton"></ct-button>

  </div>

</div>